export enum EnrollmentTypeEnum {
  JointApplicationMaintenance = 'ADD_JOINT_APPLICANT',
}

